import Icon from "@chakra-ui/icon"
import { Flex, Heading } from "@chakra-ui/layout"
import React from "react"
import PensilLeftIcon from "../../assets/pencil-left.svg"

const EduTopBanner = () => {
    return (
        <Flex
            w="100%"
            h={["110px", "166px", "172px", "176px"]}
            bg="_olive"
            justify={["center", "center"]}
            align={["flex-start", "flex-start", "flex-start", "center"]}
            mt={["5px", "10px", "16px"]}
            pt="10px"
            pos="relative"
        >
            <Heading
                fontSize={["24px", "32px", "38px", "48px"]}
                fontWeight="900"
                color="#fff"
                textTransform="uppercase"
                pl={["10px", "40px", "40px", null]}
                pr={["10px", "40px", "40px"]}
                textAlign="center"
                maxW={["510px", "510px", "540px", "860px"]}
            >
                Образовањем до посла који се воли
            </Heading>
            <Flex
                transform={[
                    "translate(0px, 24px)",
                    "translate(0px, 22px)",
                    "translate(0px, 34px)",
                    "translate(0px, 34px)",
                    "translate(0px, 54px)",
                ]}
                pos="absolute"
                bottom="0"
                right="0"
            >
                <Icon
                    as={PensilLeftIcon}
                    w={["260px", "260px", "420px", "420px", "570px"]}
                    h="100%"
                    transform="rotateY(180deg)"
                />
            </Flex>
        </Flex>
    )
}

export default EduTopBanner
